import React, { useState } from 'react';

const RenewableEnergy = () => {
  const [activeProblem, setActiveProblem] = useState(0);

  const problems = [
    {
      question: "Large, irregularly shaped components like solar panels and turbine blades require unique handling and transport solutions.",
      answer: "Tailored logistics planning with specialized equipment for solar panels, turbine blades, and sensitive electrical systems."
    },
    {
      question: "Unpredictable delivery schedules can push back installation timelines and disrupt project flow.",
      answer: "Dedicated fleets and real-time tracking ensuring components arrive exactly when needed."
    },
    {
      question: "Fluctuating timelines and material needs make it hard to maintain the right inventory levels.",
      answer: "Flexible, scalable warehousing solutions tailored to your evolving operational needs."
    },
    {
      question: "Shippers are increasingly expected to reduce emissions and align with environmental goals.",
      answer: "Carbon-neutral shipping options and optimized routing to reduce environmental impact."
    }
  ];

  return (
    <div className="automotive-logistics">
      {/* First Section - Hero */}
      <section className="hero-section hero-margin">
        <div className="hero-overlay">
          <div className="container">
            <div className="hero-content">
              <h1>Renewable Energy</h1>
              <p className="hero-tagline">Specialized and environmentally-responsible solutions to keep clean energy projects on track.</p>
              
            </div>
          </div>
        </div>
      </section>

      {/* Second Section - Problem/Solution Boxes */}
      <section className="problems-section">
        <div className="container">
          <div className="section-header">
            <h2>Powering Through Your Biggest Logistics Challenges</h2>
            <p>Is your supply chain keeping up with the demands of complex, time-sensitive energy projects?</p>
          </div>
          
          <div className="problems-grid">
            {problems.map((problem, index) => (
              <div 
                key={index}
                className={`problem-box ${activeProblem === index ? 'active' : ''}`}
                onMouseEnter={() => setActiveProblem(index)}
              >
                <div className="problem-question">
                  <div className="question-icon">
                    <span>{index + 1}</span>
                  </div>
                  <h3>{problem.question}</h3>
                </div>
                <div className="problem-answer">
                  <p>{problem.answer}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="solution-display">
            <div className="solution-content">
              <div>
                <h3>Our Solution</h3>
                <p>{problems[activeProblem].answer}</p>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-5">
           
           
          </div>
        </div>
      </section>

      {/* Third Section - Partnership */}
      <section className="partnership-section ">
        <div className="container">
          <div className="partnership-content">
            <div className="partnership-image">
              <img src={`${process.env.PUBLIC_URL}/assets/images/bg/energy.jpg`} alt="Renewable Energy Logistics" />
            </div>
            <div className="partnership-text">
              <h2>Renewable Energy</h2>
              <h3>Partner with Trackline XR</h3>
              <p>For a logistics partner that understands your business.</p>
              <p>Whether you're moving parts, assemblies, or finished products, we deliver with precision and speed. Reach out to see how we can streamline your logistics.</p>
             
            </div>
          </div>
        </div>
        <style jsx>{`
    
.automotive-logistics {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  line-height: 1.6;
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.text-center {
  text-align: center;
}

.mt-5 {
  margin-top: 3rem;
}

/* Hero Section */
.hero-section {
  background: #00358d;
  background-position: center;
  background-attachment: scroll;
  color: white;
  padding: 110px 0;
  position: relative;
}
  .hero-margin{
  margin-left: 20px;
    margin-right: 20px;
    border-radius: 20px;
}
  }

.hero-overlay {
  position: relative;
  z-index: 2;
}

.hero-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.hero-content h1 {
  font-size: 4rem;
 color: white;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-top: 7rem;
}

.hero-tagline {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  font-weight: 500;
  opacity: 0.95;
}

.hero-subtitle {
  font-size: 1.3rem;
  margin-bottom: 2.5rem;
  opacity: 0.9;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* CTA Button */
.cta-button {
  background: linear-gradient(135deg, #e30613, #c10510);
  color: white;
  border: none;
  padding: 16px 45px;
  font-size: 1.1rem;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(227, 6, 19, 0.3);
  position: relative;
  overflow: hidden;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(227, 6, 19, 0.4);
  background: linear-gradient(135deg, #c10510, #a0040d);
}

.cta-button:active {
  transform: translateY(-1px);
}

/* Problems Section */
.problems-section {
  padding: 100px 0;
  background-color: #f8fafc;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 2.8rem;
  margin-bottom: 1.5rem;
  color: #1a202c;
  font-weight: 700;
  position: relative;
  display: inline-block;
}

.section-header h2:after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #e30613, #c10510);
  border-radius: 2px;
}

.section-header p {
  font-size: 1.3rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.7;
}

.problems-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 50px;
}

.problem-box {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  cursor: pointer;
  border-left: 5px solid transparent;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.problem-box:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(227, 6, 19, 0.03), rgba(193, 5, 16, 0.03));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.problem-box:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
}

.problem-box:hover:before {
  opacity: 1;
}

.problem-box.active {
  border-left: 5px solid #e30613;
  background-color: #fff5f5;
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
}

.problem-box.active:before {
  opacity: 1;
}

.problem-question {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.question-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #e30613, #c10510);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: white;
  font-weight: 700;
  font-size: 1.1rem;
  box-shadow: 0 4px 10px rgba(227, 6, 19, 0.3);
}

.problem-question h3 {
  font-size: 1.3rem;
  margin: 0;
  color: #1a202c;
  font-weight: 600;
  line-height: 1.5;
}

.problem-answer {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  display: none;
}

.problem-box.active .problem-answer {
  display: block;
  animation: fadeInUp 0.5s ease;
}

@keyframes fadeInUp {
  from { 
    opacity: 0; 
    transform: translateY(10px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.problem-answer p {
  margin: 0;
  color: #e30613;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 1.6;
}

.solution-display {
  background: white;
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
  border-top: 5px solid #e30613;
  position: relative;
  overflow: hidden;
}

.solution-display:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(227, 6, 19, 0.02), rgba(193, 5, 16, 0.02));
}

.solution-content {
  display: flex;
  align-items: flex-start;
  gap: 25px;
  position: relative;
  z-index: 2;
}

.solution-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #e30613, #c10510);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: white;
  box-shadow: 0 4px 15px rgba(227, 6, 19, 0.3);
}

.solution-icon svg {
  width: 24px;
  height: 24px;
}

.solution-content h3 {
  color: #e30613;
  margin-bottom: 15px;
  font-size: 1.8rem;
  font-weight: 700;
}

.solution-content p {
  font-size: 1.4rem;
  margin: 0;
  color: #1a202c;
  font-weight: 500;
  line-height: 1.6;
}

/* Partnership Section */
.partnership-section {
  padding: 100px 0;
  background-color: white;
}

.partnership-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.partnership-image {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease;
}

.partnership-image:hover {
  transform: scale(1.02);
}

.partnership-image img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block;
}

.partnership-text {
  padding-left: 20px;
}

.partnership-text h2 {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: 600;
}

.partnership-text h3 {
  font-size: 2.8rem;
  margin-bottom: 1.5rem;
  font-weight: 800;
  color: #1a202c;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  display: inline-block;
}

.partnership-text h3:after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #e30613, #c10510);
  border-radius: 2px;
}

.partnership-text p {
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  line-height: 1.7;
  color: #4a5568;
}

.partnership-text .cta-button {
  margin-top: 10px;
}

/* Responsive Design */
@media (max-width: 992px) {
  .problems-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  
  .partnership-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .partnership-text {
    padding-left: 0;
    text-align: center;
  }
  
  .partnership-text h3:after {
    left: 50%;
    transform: translateX(-50%);
  }
  
  .hero-content h1 {
    font-size: 3.2rem;
  }
  
  .partnership-text h3 {
    font-size: 2.4rem;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 80px 0;
    background-attachment: scroll;
  }
  
  .hero-content h1 {
    font-size: 2.5rem;
  }
  
  .hero-tagline {
    font-size: 1.5rem;
  }
  
  .section-header h2 {
    font-size: 2.2rem;
  }
  
  .problems-section,
  .partnership-section {
    padding: 70px 0;
  }
  
  .problem-box {
    padding: 25px;
    min-height: 160px;
  }
  
  .problem-question h3 {
    font-size: 1.2rem;
  }
  
  .solution-display {
    padding: 30px;
  }
  
  .solution-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  .solution-content h3 {
    font-size: 1.6rem;
  }
  
  .solution-content p {
    font-size: 1.2rem;
  }
  
  .partnership-text h2 {
    font-size: 1.5rem;
  }
  
  .partnership-text h3 {
    font-size: 2rem;
  }
  
  .partnership-text p {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 15px;
  }
  
  .hero-content h1 {
    font-size: 2rem;
  }
  
  .hero-tagline {
    font-size: 1.2rem;
  }
  
  .cta-button {
    padding: 14px 35px;
    font-size: 1rem;
  }
  
  .section-header h2 {
    font-size: 1.8rem;
  }
  
  .section-header p {
    font-size: 1.1rem;
  }
  
  .problem-question {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .partnership-image img {
    height: 350px;
  }
}
  `}</style>
      </section>
    </div>
  );
};

export default RenewableEnergy;